import global from '@/store/global';
import modal from '@/store/modal';

export default class TrackClient {
  // constructor variables
  timeToReactInSeconds!: number;
  cFuction!: Function;
  showWarningAt!: number;
  showWarning!: boolean;

  // interval
  private interval!: number;

  // holds value of time. is increased by seconds
  private timePassed: number = 0;

  // events those will be listened to
  private events: string[] = [
    'click',
    'mousemove',
    'mouseup',
    'keypress',
    'scroll',
    'touchstart',
  ];

  /**
   * Requires time to react in seconds and callback function
   *
   * @param timeToReactInSeconds {number}
   * @param showWarningAt {number} If given 0, no warning will be displayed
   * @param cFuction {Function}
   */
  constructor(
    timeToReactInSeconds: number,
    showWarningAt: number = 60,
    cFuction: Function,
  ) {
    if (!timeToReactInSeconds)
      throw new Error("\n\nLength of allowed inactivity wasn't set");
    if (!cFuction) throw new Error("\n\nCallback function wasn't specified");

    this.timeToReactInSeconds = timeToReactInSeconds;
    this.showWarning = showWarningAt > 0;
    this.showWarningAt = showWarningAt;
    this.cFuction = cFuction;
  }

  /**
   * Start to track client
   */
  startTracking(): void {
    if (import.meta.env.NODE_ENV === 'development') {
      console.log('tracking started');
    }

    this.timePassed = 0;
    this._setupListeners(this.events);

    this.interval = <any>setInterval(() => {
      // if the interval is reached, stop tracking and clean up listeners
      if (this.timePassed >= this.timeToReactInSeconds) {
        this.stopTracking();
        this.cFuction();

        // else add one second and check if have to display warning window
      } else {
        this.timePassed += 1;

        const remainingTime = this.timeToReactInSeconds - this.timePassed;
        global.trackingClientRemainingTime = remainingTime;

        // store remaining time
        if (this.showWarning && this.showWarningAt >= remainingTime) {
          // if modal is not opened, open interval
          if (!modal.modalOpened) {
            modal.modalType = 'invalidate';
            modal.modalOpened = true;
          }
        }
      }
    }, 1000);
  }

  /**
   * Cleans up everything
   */
  stopTracking(): void {
    if (import.meta.env.NODE_ENV === 'development') {
      console.log('tracking stoped');
    }

    this._removeListeners(this.events);
    this._removeInterval();
    this.timePassed = 0;
  }

  /**
   * Create listeners for defined events
   *
   * @param events {string[]}
   */
  private _setupListeners(events: string[]): void {
    events.forEach((event) => {
      document.body.addEventListener(event, this.listenerBridge);
    });
  }

  /**
   * Remove listeners when neccessary
   *
   * @param events {string[]}
   */
  private _removeListeners(events: string[]): void {
    events.forEach((event) => {
      document.body.removeEventListener(event, this.listenerBridge);
    });
  }

  /**
   * Reset time that passed since last inactivity
   */
  listenerBridge = () => this._refreshInterval();
  private _refreshInterval(): void {
    this.timePassed = 0;
  }

  /**
   * Remove interval
   */
  private _removeInterval(): void {
    clearInterval(this.interval);
  }
}
